import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import BaseButton from 'reservations/base/components/BaseButton';
import BaseModal, {
  type ModalProps
} from 'reservations/base/components/BaseModal';
import { useDeleteSavedPaymentMethodMutation } from 'reservations/dinerAccount/queries/deleteSavedPaymentMethodMutation';
import { type PaymentMethodListItem } from 'reservations/dinerAccount/queries/getCurrentUser';
import { CardInformation } from 'reservations/payments/components/CardInformation';
import { useDinerPaymentMethods } from 'reservations/payments/hooks/useDinerPaymentMethods';

interface DeletePaymentMethodModalProps extends ModalProps {
  paymentMethodId: string | null;
  handleSuccess: () => void;
}

type MutationParam = {
  paymentMethodId: string;
};

export default function DeletePaymentMethodModal({
  paymentMethodId,
  isOpen,
  onClose,
  handleSuccess
}: DeletePaymentMethodModalProps) {
  const mutation = useDeleteSavedPaymentMethodMutation({ handleSuccess });
  const { paymentMethods } = useDinerPaymentMethods();
  const paymentMethodDetails = paymentMethods.find(
    paymentMethod => paymentMethod.id === paymentMethodId
  );

  const onSubmit = () => {
    mutation.mutate({ paymentMethodId } as MutationParam);
  };

  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      title="Remove Saved Card?"
      content={
        paymentMethodDetails ? <ModalContent {...paymentMethodDetails} /> : null
      }
    >
      <Grid container gap="10px" direction="column">
        <Grid item>
          <BaseButton label="Remove Card" onClick={onSubmit} />
        </Grid>
        <Grid item>
          <BaseButton label="Cancel" variant="text" onClick={onClose} />
        </Grid>
      </Grid>
    </BaseModal>
  );
}

const ModalContent = ({
  cardType,
  cardLast4,
  cardExpMonth,
  cardExpYear
}: PaymentMethodListItem) => (
  <Box display="flex" flexDirection="column" gap="16px">
    <Typography>
      Are you sure you want to remove this saved card payment method?
    </Typography>

    <Box display="flex" flexDirection="row" alignItems="center">
      <CardInformation
        cardType={cardType}
        cardLast4={cardLast4}
        cardExpMonth={cardExpMonth}
        cardExpYear={cardExpYear}
      />
    </Box>
  </Box>
);
